import { FC } from 'react';

interface IRocketChatProps {
  url?: string;
}
export const RocketchatSidebar: FC<IRocketChatProps> = ({ url }) => {
  return <iframe title="rocketchat iframe" height="100%" width="100%" src={url}></iframe>;
};
